import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GAutoCompleteComponent } from './g-auto-complete/g-auto-complete.component';

@NgModule({
   imports: [CommonModule],
    declarations: [
        GAutoCompleteComponent
    ],
    exports: [
    GAutoCompleteComponent
    ]
})
export class T2AutoCompleteLocationModule  {

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/t2-autocomplete-location/t2-autocomplete-location.module.ts